import { Component, ContentChild, ElementRef, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-loading-template',
    templateUrl: './loading-template.component.html',
    styleUrls: ['./loading-template.component.scss']
})
export class LoadingTemplateComponent {

    /** ProjectedContent */
    @ContentChild(TemplateRef) ProjectedContent!: TemplateRef<any>;

    /** hasProjectedContent */
    get hasProjectedContent() {
        return !!this.ProjectedContent;
    }

    /** DisplayText */
    @Input() DisplayText: string | undefined;

    /** Sub Text */
    @Input() SubText: string | undefined;

}
